<template>
    <div v-if="$root.isMobile" class="mobile-page-title">
        <div class="d-flex justify-content-between align-items-center">
            <button type="button" class="btn btn-primary btn-sm" @click="showFilters = true">
                <i class="fal fa-sliders-h"></i> Filtri
            </button>
            <h4 class="mb-0 font-weight-bold flex-grow-1 text-center">
                Fatture
            </h4>
            <div style="width: 80px;"></div>
        </div>
    </div>
    <div class="kt-portlet__head">
        <form v-if="!$root.isMobile" class="isprint-filter" autocomplete="off"
            :style="{ marginBottom: $root.isTablet ? '100px' : '' }">
            <div class="form-group">
                <label>Agente</label><br>
                <input class="form-control form-control-sm" autocomplete="off" name="adasd" placeholder="Agente"
                    type="text" style="width:150px" v-model="search.DESCRIZIONE_AGENTE.VALUE">
            </div>

            <div class="form-group">
                <label>Numero Fattura</label><br>
                <input class="form-control form-control-sm" autocomplete="off" name="adasd" placeholder="Numero Fattura"
                    type="text" style="width:150px" v-model="search.NUMERO_FATTURA.VALUE">
            </div>

            <div class="form-group">
                <label>Tipologia Contratto</label><br>
                <select class="form-control form-control-sm" style="width: 150px;" v-model="search.FK_ID_TIPO.VALUE">
                    <option value="">Luce / Gas</option>
                    <option value="1">Luce</option>
                    <option value="2">Gas</option>
                </select>
            </div>

            <div class="form-group">
                <label>Cliente</label><br>
                <input class="form-control form-control-sm" autocomplete="off" name="adasd" placeholder="Denominazione"
                    type="text" style="width:150px" v-model="search.DENOMINAZIONE.VALUE">
            </div>
            <div class="form-group ">
                <label>Data Registrazione</label><br>
                <DatePicker placeholder="data" autocomplete="off" :dim="'sm'" type="text" style="width:150px"
                    v-model="search.DATA_REGISTRAZIONE.VALUE">
                </DatePicker>
            </div>
            <div class="form-group ">
                <label>Data Scadenza</label><br>
                <DatePicker placeholder="data" autocomplete="off" :dim="'sm'" type="text" style="width:150px"
                    v-model="search.DATA_SCADENZA.VALUE">
                </DatePicker>
            </div>
            <div class="form-group ">
                <label>Data Contabilizzazione</label><br>
                <DatePicker placeholder="data" autocomplete="off" :dim="'sm'" type="text" style="width:150px"
                    v-model="search.DATA_CONTABILIZZAZIONE.VALUE">
                </DatePicker>
            </div>
            <div class="form-group">
                <label>Pagata</label><br>
                <select class="form-control form-control-sm" style="width: 150px;" v-model="search.PAGATA.VALUE">
                    <option value="">Tutti</option>
                    <option value="1">Pagata</option>
                    <option value="0">Non Pagata</option>
                </select>
            </div>
            <div class="form-group">
                <label>Importo</label><br>
                <input class="form-control form-control-sm" autocomplete="off" name="adasd" placeholder="Importo"
                    type="text" style="width:150px" v-model="search.IMPORTO.VALUE">
            </div>
        </form>
        <div v-if="$root.isMobile">


            <div class="offcanvas-backdrop" :class="{ show: showFilters }" @click.self="showFilters = false">
                <aside class="offcanvas-panel" :class="{ open: showFilters }" role="dialog" aria-modal="true">
                    <div class="offcanvas-header" style="background: linear-gradient(135deg, #800080, #004B80);">
                        <h6 class="mb-0 text-light"><i class="fal fa-filter"></i> Filtri ricerca</h6>
                        <button type="button" class="btn btn-light btn-sm" @click="showFilters = false">
                            <i class="fal fa-times"></i>
                        </button>
                    </div>
                    <div class="offcanvas-body">
                        <form class="isprint-filter" autocomplete="off"
                            :style="{ marginBottom: $root.isTablet ? '100px' : '' }">
                            <div class="form-group">
                                <label>Agente:</label><br>
                                <input class="form-control form-control-sm" autocomplete="off" name="adasd"
                                    placeholder="Agente" type="text" style="width:290px"
                                    v-model="search.DESCRIZIONE_AGENTE.VALUE">
                            </div>
                            <div class="form-group">
                                <label>Numero Fattura:</label><br>
                                <input class="form-control form-control-sm" autocomplete="off" name="adasd"
                                    placeholder="Numero Fattura" type="text" style="width:290px"
                                    v-model="search.NUMERO_FATTURA.VALUE">
                            </div>
                            
                            <div class="form-group">
                                <label>Cliente:</label><br>
                                <input class="form-control form-control-sm" autocomplete="off" name="adasd"
                                    placeholder="Denominazione" type="text" style="width:290px"
                                    v-model="search.DENOMINAZIONE.VALUE">
                            </div>

                            <div class="form-group">
                                <label>Tipologia Contratto:</label><br>
                                <select class="form-control form-control-sm" style="width: 140px;"
                                    v-model="search.FK_ID_TIPO.VALUE">
                                    <option value="">Luce / Gas</option>
                                    <option value="1">Luce</option>
                                    <option value="2">Gas</option>
                                </select>
                            </div>

                            <div class="form-group">
                                <label>Data Registrazione</label><br>
                                <DatePicker placeholder="data" autocomplete="off" :dim="'sm'" type="text"
                                    style="width:140px" v-model="search.DATA_REGISTRAZIONE.VALUE">
                                </DatePicker>
                            </div>
                            <div class="form-group">
                                <label>Data Scadenza</label><br>
                                <DatePicker placeholder="data" autocomplete="off" :dim="'sm'" type="text"
                                    style="width:140px" v-model="search.DATA_SCADENZA.VALUE">
                                </DatePicker>
                            </div>
                            <div class="form-group">
                                <label>Data Contabilizz.</label><br>
                                <DatePicker placeholder="data" autocomplete="off" :dim="'sm'" type="text"
                                    style="width:140px" v-model="search.DATA_CONTABILIZZAZIONE.VALUE">
                                </DatePicker>
                            </div>
                            <div class="form-group">
                                <label>Importo</label><br>
                                <input class="form-control form-control-sm" autocomplete="off" name="adasd"
                                    placeholder="Importo" type="text" style="width:90px"
                                    v-model="search.IMPORTO.VALUE">
                            </div>
                            <div class="form-group">
                                <label>Incassato:</label><br>
                                <input class="form-control form-control-sm" autocomplete="off" name="adasd"
                                    placeholder="Incassato" type="text" style="width:90px"
                                    v-model="search.INCASSATO.VALUE">
                            </div>
                            <div class="form-group">
                                <label>Saldo:</label><br>
                                <input class="form-control form-control-sm" autocomplete="off" name="adasd"
                                    placeholder="Saldo" type="text" style="width:90px" v-model="search.SALDO.VALUE">
                            </div>
                        </form>
                    </div>
                </aside>
            </div>
        </div>
    </div>
    <div class="isprint-grid-container">
        <table v-if="!$root.isMobile" class="isprint-grid shadow">
            <thead class="isprint-grid-thead">
                <tr style="left:0px;background: linear-gradient(135deg, #800080, #004B80);;color:#fff">
                    <th style="width:10%"><span>Numero Fattura</span></th>
                    <th style="width:17%"><span>Agente</span></th>
                    <th style="width:20%"><span>Cliente</span></th>
                    <th style="width:12%"><span>Date</span></th>
                    <th style="width:5%"><span>MC/KWH</span></th>
                    <th style="width:4%"><span>Fattore</span></th>
                    <th style="width:4%"><span>Gettone</span></th>
                    <th style="width:10%"><span>Stato Pagamenti</span></th>
                    <th style="width:8%"><span>Azioni</span></th>
                </tr>
            </thead>
            <tbody class="isprint-grid-tbody" style="font-size:14px !important">
                <tr style="left: 0px; height: 50px" v-for="fattura in paginatedList.arr"
                    v-bind:key="fattura.ID_FATTURA">
                    <td style="width:10%">
                        <span v-if="fattura.ELABORATO == 1"  class="badge bg-success">
                            {{ fattura.NUMERO_FATTURA }} 
                        </span>
                        <span v-else class="badge bg-danger lift-panel" @click="openInfoElaborazione(fattura)">
                            {{ fattura.NUMERO_FATTURA }}
                            <i class="fa fa-info-circle" aria-hidden="true"></i>
                        </span>
                    </td>

                    <td style="width:17%">
                        <span style="margin-right: 8px">
                            <i class="fad fa-user-secret" style="font-size: 20px;"></i>
                        </span>

                        <strong>{{ fattura.DESCRIZIONE_AGENTE || '' }}</strong><br>
                    </td>

                    <td style="width:20%">
                        <div class="row">
                            <div class="col-1 d-flex justify-content-center align-items-center">
                                 <i v-if="(fattura.POD).length > 1" class="fas fa-lightbulb text-warning" style="font-size: 20px;"></i>
                                 <i v-else-if="(fattura.PDR).length > 1" class="fas fa-gas-pump text-danger" style="font-size: 20px;"></i>
                            </div>
                            <div class="col-11">
                                <strong>{{fattura.DENOMINAZIONE || '' }}</strong><br>
                                <span v-if="(fattura.POD).length > 1" style="margin-right: 8px; display: block;">
                                    <span v-if="fattura.FK_ID_CONTRATTO && fattura.FK_ID_CONTRATTO > 0"
                                          class="contratto-indicator"
                                          title="Contratto associato"></span>
                                    <strong>POD: </strong>{{ fattura.POD }}
                                </span>
                                <span v-else-if="(fattura.PDR).length > 1" style="margin-right: 8px; display: block;">
                                    <span v-if="fattura.FK_ID_CONTRATTO && fattura.FK_ID_CONTRATTO > 0"
                                          class="contratto-indicator"
                                          title="Contratto associato"></span>
                                    <strong>PDR: </strong>{{ fattura.PDR }}
                                </span>
                            </div>
                        </div>

                    </td>

                    <td style="width:12%">
                        <div>
                            <strong>Registrazione -</strong> 
                            {{ filters.formatDate(fattura.DATA_REGISTRAZIONE) == 'Invalid date' ? '' : filters.formatDate(fattura.DATA_REGISTRAZIONE) }}</div>
                        <div><strong>Contabilizz. -</strong> {{ filters.formatDate(fattura.DATA_CONTABILIZZAZIONE)
                            == 'Invalid date' ? '' : filters.formatDate(fattura.DATA_CONTABILIZZAZIONE) }}
                        </div>
                        <div><strong>Emissione -</strong> {{ filters.formatDate(fattura.DATA_EMISSIONE) == 'Invalid date' ? '' : filters.formatDate(fattura.DATA_EMISSIONE) }}
                        </div>
                    </td>
                    <td style="width:5%">
                        <span v-if="(fattura.POD).length > 1" class="badge">
                            {{ fattura.KWH_FATTURATI + ' KWH' }}
                        </span>

                        <span v-else-if="(fattura.PDR).length > 1" class="badge">
                            {{ fattura.MC_FATTURATI + ' MC' }}
                        </span>
                    </td>
                    <td style="width:4%;">
                        <strong style="color: #007bff;"> {{ fattura.FATTORE_FAT }}€</strong><br>
                    </td>
                    <td style="width:4%;">
                        <strong style="color: #007bff;"> {{ fattura.GETTONE_FAT }}€</strong><br>
                    </td>
                    <td style="width:10%;">
                        <span v-if="fattura.PAGATA == 0" class= "badge badge-danger text-left">
                            Da Pagare: {{ fattura.SALDO }}€
                            <hr class="mt-1 mb-1" style="height: 1px; border:none; color: white; background-color: white;">
                            Importo: {{ Math.abs(fattura.IMPORTO).toFixed(2) }}€
                        </span>
                        <span v-else-if="(fattura.PAGATA == 1  && (fattura.SALDO > 0 || fattura.IMPORTO > 0 || fattura.INCASSATO < 0))" class="badge badge-success text-left">
                            Incassato: {{ Math.abs(fattura.INCASSATO).toFixed(2) }}€<hr class="mt-1 mb-1" style="height: 1px; border:none; color: white; background-color: white;" >
                            Importo: {{ Math.abs(fattura.IMPORTO).toFixed(2) }}€
                        </span>
                    </td>

                    <td style="width:8%" class="text-center">
                        <button class="btn btn-warning btn-sm" @click="modificaFattore(fattura)" v-if="fattura.ELABORATO == 1"
                            title="Modifica il fattura">
                            <i class="fal fa-pen"></i>
                        </button>
                        <button class="btn btn-info btn-sm ml-1" @click="moreInfo(fattura.ID_FATTURA)"
                            title="Maggiori Informazioni">
                            <i class="fal fa-info-circle"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-if="$root.isMobile" class="row justify-content-center">
            <div class="col-12 mb-4" v-for="fattura in paginatedList.arr" :key="fattura.ID_FATTURA">
                <div class="card shadow border-0 text-center p-3" style="border-radius: 20px;">
                    <div class="card-body">
                        <i class="fad fa-file-invoice-dollar fa-6x mb-4"></i>
                        <div class="font-weight-bold text-ecomm h4 mb-3">
                            Fattura #{{ fattura.NUMERO_FATTURA }}
                        </div>

                        <div>
                            <p><strong>Agente:</strong> {{ fattura.DESCRIZIONE_AGENTE || 'Non disponibile' }}</p>
                            <p><strong>Cliente:</strong> {{ fattura.DENOMINAZIONE || 'Non disponibile' }}</p>
                            <p><strong>Tipo:</strong>
                                <span v-if="fattura.POD">
                                    <span v-if="fattura.FK_ID_CONTRATTO && fattura.FK_ID_CONTRATTO > 0"
                                          class="contratto-indicator"
                                          title="Contratto associato"></span>
                                    POD: {{ fattura.POD }}
                                </span>
                                <span v-else-if="fattura.PDR">
                                    <span v-if="fattura.FK_ID_CONTRATTO && fattura.FK_ID_CONTRATTO > 0"
                                          class="contratto-indicator"
                                          title="Contratto associato"></span>
                                    PDR: {{ fattura.PDR }}
                                </span>
                            </p>
                        </div>
                        <div>
                            <p><strong>Registrazione:</strong> {{
                                filters.formatDate(fattura.DATA_REGISTRAZIONE) == 'Invalid date' ? '—' :
                                filters.formatDate(fattura.DATA_REGISTRAZIONE)}}</p>
                            <p><strong>Contabilizzazione:</strong> {{ filters.formatDate(fattura.DATA_CONTABILIZZAZIONE)
                                == 'Invalid date' ? '—' : filters.formatDate(fattura.DATA_CONTABILIZZAZIONE)}}</p>
                            <p><strong>Inserimento:</strong> {{ filters.formatDate(fattura.DATA_INSERIMENTO) == 'Invalid date' ? '—' : filters.formatDate(fattura.DATA_INSERIMENTO) }}</p>
                        </div>
                        <div>
                            <p><strong>Quantità Fatturata: </strong>
                                <span v-if="fattura.POD"> {{ fattura.KWH_FATTURATI }} KWH</span>
                                <span v-else-if="fattura.PDR"> {{ fattura.MC_FATTURATI }} MC</span>
                            </p>
                        </div>
                        <div>
                            <p><strong>Fattore:</strong> <strong>{{ fattura.FATTORE_FAT }}</strong><br>
                            </p>
                        </div>
                        <div>
                            <table class="table">
                                <tr>
                                    <td><p><strong>Importo:</strong> {{ fattura.IMPORTO }}€</p></td>
                                    <td><p><strong>Incassato:</strong> {{ fattura.INCASSATO }}€</p></td>
                                    <td> <p><strong>Saldo:</strong> {{ fattura.SALDO }}€</p></td>
                                </tr>
                            </table>
                            
                            
                           
                        </div>
                        <div class="d-flex justify-content-between">
                            <button class="btn btn-warning btn-sm" @click="modificaFattore(fattura)"
                                title="Modifica il contratto">
                                <i class="fal fa-pen"></i>
                            </button>
                            <button class="btn btn-info btn-sm" @click="moreInfo(fattura.ID_FATTURA)"
                                title="Modifica il contratto">
                                <i class="fal fa-info-circle"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Pagine v-model="search.PAGINATION.PAGE_NUMBER" :numrighe="paginatedList.count"
            :numpagine="search.PAGINATION.LENGTH">
        </Pagine>
    </div>


    <div class="modal fade" id="popUpInfo" data-backdrop="true" role="dialog" aria-modal="true">
        <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
            <div class="modal-content">
                <div class="modal-header text-white"
                    style="background: linear-gradient(135deg, #800080, #004B80); color: #fff;">
                    <h5 class="modal-title" id="modaleFatturaLabel">Dettagli Fattura</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="card shadow-sm lift-panel border">
                                <div class="card-body">
                                    <h6 class="card-title"><i class="fas fa-file-invoice text-primary"></i> Numero
                                        Fattura</h6>
                                    <p class="card-text">{{ infoSelezionata.NUMERO_FATTURA }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card shadow-sm lift-panel border">
                                <div class="card-body">
                                    <h6 class="card-title"><i class="fas fa-file-invoice text-primary"></i> Numero
                                        Contratto</h6>
                                    <p class="card-text">{{ infoSelezionata.CODICE_CONTRATTO }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card shadow-sm lift-panel border">
                                <div class="card-body">
                                    <h6 class="card-title"><i class="fas fa-user text-primary"></i> Cliente</h6>
                                    <p class="card-text">{{ infoSelezionata.DENOMINAZIONE }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card shadow-sm lift-panel border">
                                <div class="card-body">
                                    <h6 class="card-title"><i class="fas fa-id-badge text-primary"></i> Agente</h6>
                                    <p class="card-text">{{ infoSelezionata.DESCRIZIONE_AGENTE }} <small>({{
                                            infoSelezionata.CODICE_AGENTE }})</small></p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card shadow-sm lift-panel border">
                                <div class="card-body">
                                    <h6 class="card-title"><i class="fas fa-calendar-day text-primary"></i> Data
                                        Registrazione</h6>
                                    <p class="card-text">{{ filters.formatDate(infoSelezionata.DATA_REGISTRAZIONE) == 'Invalid date' ? 'Non definita' : filters.formatDate(infoSelezionata.DATA_REGISTRAZIONE) }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card shadow-sm lift-panel border">
                                <div class="card-body">
                                    <h6 class="card-title"><i class="fas fa-calendar-day text-primary"></i> Data
                                        Competenza Da</h6>
                                    <p class="card-text">{{ filters.formatDate(infoSelezionata.DATA_COMPETENZA_DA) == 'Invalid date' ? 'Non definita' : filters.formatDate(infoSelezionata.DATA_COMPETENZA_DA) }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card shadow-sm lift-panel border">
                                <div class="card-body">
                                    <h6 class="card-title"><i class="fas fa-calendar-day text-primary"></i> Data
                                        Competenza A</h6>
                                    <p class="card-text">{{ filters.formatDate(infoSelezionata.DATA_COMPETENZA_A) == 'Invalid date' ? 'Non definita' : filters.formatDate(infoSelezionata.DATA_COMPETENZA_A) }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card shadow-sm lift-panel border">
                                <div class="card-body">
                                    <h6 class="card-title"><i class="fas fa-calendar-check text-primary"></i> Data
                                        Scadenza</h6>
                                    <p class="card-text">{{ filters.formatDate(infoSelezionata.DATA_SCADENZA) == 'Invalid date' ? 'Non definita' : filters.formatDate(infoSelezionata.DATA_SCADENZA)}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card shadow-sm lift-panel border">
                                <div class="card-body">
                                    <h6 class="card-title"><i class="fas fa-calendar text-primary"></i> Data
                                        Contabilizzazione</h6>
                                    <p class="card-text">{{ filters.formatDate(infoSelezionata.DATA_CONTABILIZZAZIONE) == 'Invalid date' ? 'Non definita' : filters.formatDate(infoSelezionata.DATA_CONTABILIZZAZIONE)  }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card shadow-sm lift-panel border">
                                <div class="card-body">
                                    <h6 class="card-title"><i class="fas fa-euro-sign text-primary"></i> Importo</h6>
                                    <p class="card-text">{{ infoSelezionata.IMPORTO }} €</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card shadow-sm lift-panel border">
                                <div class="card-body">
                                    <h6 class="card-title"><i class="fas fa-money-check text-primary"></i> Incassato
                                    </h6>
                                    <p class="card-text">{{ infoSelezionata.INCASSATO }} €</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card shadow-sm lift-panel border">
                                <div class="card-body">
                                    <h6 class="card-title"><i class="fas fa-balance-scale text-primary"></i> Saldo</h6>
                                    <p class="card-text">{{ infoSelezionata.SALDO }} €</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card shadow-sm lift-panel border">
                                <div class="card-body">
                                    <h6 class="card-title"><i class="fas fa-cogs text-primary"></i> Commodity</h6>
                                    <p class="card-text">{{ infoSelezionata.COMMODITY }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card shadow-sm lift-panel border">
                                <div class="card-body">
                                    <h6 class="card-title"><i class="fas fa-box text-primary"></i> Prodotto</h6>
                                    <p class="card-text">{{ infoSelezionata.PRODOTTO }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card shadow-sm lift-panel border">
                                <div class="card-body">
                                    <h6 class="card-title"><i class="fas fa-industry text-primary"></i> Impianto</h6>
                                    <p class="card-text">{{ infoSelezionata.IMPIANTO }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card shadow-sm lift-panel border">
                                <div class="card-body">
                                    <h6 class="card-title"><i class="fas fa-plug text-primary"></i> POD/PDR</h6>
                                    <p class="card-text">{{ infoSelezionata.FK_ID_TIPO == 1 ? infoSelezionata.POD :
                                        infoSelezionata.PDR }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card shadow-sm lift-panel border">
                                <div class="card-body">
                                    <h6 class="card-title"><i class="fas fa-tachometer-alt text-primary"></i> MC/KWH
                                    </h6>
                                    <p class="card-text">{{ infoSelezionata.FK_ID_TIPO == 2 ?
                                        infoSelezionata.MC_FATTURATI + ' MC' :
                                        infoSelezionata.KWH_FATTURATI + ' KWH' }}</p>
                                </div>
                            </div>
                        </div>
                         <div class="col-md-6">
                            <div class="card shadow-sm lift-panel border">
                                <div class="card-body">
                                    <h6 class="card-title"><i class="fas fa-industry text-primary"></i> Tipologia</h6>
                                    <p class="card-text">{{ infoSelezionata.TIPO_RECORD == '' ? 'Non definito' : infoSelezionata.TIPO_RECORD }}</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal"><i class="fas fa-times"></i>
                        Chiudi</button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="popUpFattura" data-backdrop="true" role="dialog" aria-modal="true">
        <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
            <div class="modal-content">
                <div class="modal-header text-white" style="background: linear-gradient(135deg, #800080, #004B80); color: #fff;">
                    
                    <h5 class="modal-title" id="modaleFatturaLabel"><i class="fal fa-file-invoice-dollar fa-fw" style="color:#fff"></i> Modifica Fattura</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row" v-if="this.$root.test == false">
                        <div :class="{
                            'col-md-12': fatturaSelezionata.ELABORATO != 1, 
                            'col-md-3': fatturaSelezionata.ELABORATO == 1
                        }">
                        <label for="">Fattore</label>
                           <input type="text" class="form-control" placeholder="Modifica Fattore" v-model="fatturaSelezionata.FATTORE_FAT">
                        </div>
                         <div class="col-md-3" v-if="fatturaSelezionata.ELABORATO == 1">
                            <label for="">Incassato</label>
                            <div class="input-group" >
                                <input  type="text" class="form-control" placeholder="Incrementa Incassato" v-model="fatturaSelezionata.INCASSATO">
                                 <span class="input-group-text" id="basic-addon1">€</span>
                            </div>
                        </div>
                        <div class="col-md-3" v-if="fatturaSelezionata.ELABORATO == 1">
                            <label for="">Importo</label>
                            <div class="input-group">
                                <input disabled  type="text" class="form-control" placeholder="Incrementa Incassato" v-model="fatturaSelezionata.IMPORTO">
                                 <span class="input-group-text" id="basic-addon1">€</span>
                            </div>
                        </div>
                        <div class="col-md-3"  v-if="fatturaSelezionata.ELABORATO == 1">
                            <label for="">Saldo</label>
                            <div class="input-group">
                                <input disabled  type="text" class="form-control" placeholder="Incrementa Incassato" v-model="fatturaSelezionata.SALDO">
                                 <span class="input-group-text" id="basic-addon1">€</span>
                            </div>
                        </div>
                    </div>
                    <div v-else class="row">
                        <div :class="{
                            'col-md-12': fatturaSelezionata.ELABORATO != 1, 
                            'col-md-4': fatturaSelezionata.ELABORATO == 1
                        }">
                        <label for="">Fattore</label>
                           <input type="text" class="form-control" placeholder="Modifica Fattore" v-model="fatturaSelezionata.FATTORE_FAT">
                        </div>
                        <div class="col-md-2"  v-if="fatturaSelezionata.ELABORATO == 1">
                            <label for="">Mc Fatturati</label>
                            <div class="input-group">
                                <input type="text" class="form-control" placeholder="Mc Fatturati" v-model="fatturaSelezionata.MC_FATTURATI">
                            </div>
                        </div>
                         <div class="col-md-2" v-if="fatturaSelezionata.ELABORATO == 1">
                            <label for="">Incassato</label>
                            <div class="input-group" >
                                <input  type="text" class="form-control" placeholder="Incrementa Incassato" v-model="fatturaSelezionata.INCASSATO">
                                 <span class="input-group-text" id="basic-addon1">€</span>
                            </div>
                        </div>
                        <div class="col-md-2" v-if="fatturaSelezionata.ELABORATO == 1">
                            <label for="">Importo</label>
                            <div class="input-group">
                                <input disabled  type="text" class="form-control" placeholder="Incrementa Incassato" v-model="fatturaSelezionata.IMPORTO">
                                 <span class="input-group-text" id="basic-addon1">€</span>
                            </div>
                        </div>
                        <div class="col-md-2"  v-if="fatturaSelezionata.ELABORATO == 1">
                            <label for="">Saldo</label>
                            <div class="input-group">
                                <input disabled  type="text" class="form-control" placeholder="Incrementa Incassato" v-model="fatturaSelezionata.SALDO">
                                 <span class="input-group-text" id="basic-addon1">€</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal"><i class="fas fa-times"></i>
                        Chiudi</button>
                    <button class="btn btn-success float-right" v-on:click="salvaFattura()"><i class="fa fa-check"></i>
                        Salva</button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="popUpElaborazione" data-backdrop="true" role="dialog" aria-modal="true">
        <div class="modal-dialog lg modal-dialog-scrollable" role="document">
            <div class="modal-content">
                <div class="modal-header text-white"
                    style="background: linear-gradient(135deg, #800080, #004B80); color: #fff;">
                    <h5 class="modal-title" id="modaleFatturaLabel">Maggiori Informazioni sull'elaborazione</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-12 text-center">
                            <div v-if="infoElab.ELABORATO == 2" class="alert alert-warning" role="alert">
                                <h4 class="alert-heading text-center"> <i class="fa fa-info-circle" aria-hidden="true"></i></h4>
                                Sembra che questa fattura non sia stata elaborata completamente,
                                Manca da caricare il file di tipo "Fatturato" oppure non c'è alcuna 
                                corrispondenza tra i file caricati
                            </div>
                            <div v-else-if="infoElab.ELABORATO == 3" class="alert alert-warning" role="alert">
                                <h4 class="alert-heading text-center"> <i class="fa fa-info-circle" aria-hidden="true"></i></h4>
                                Sembra che questa fattura non sia stata elaborata completamente,
                                Manca da caricare il file di tipo "Scadenzario - Singolo Agente" oppure non c'è alcuna 
                                corrispondenza tra i file caricati
                            </div>
                            <div v-else-if="infoElab.ELABORATO == 0" class="alert alert-warning" role="alert">
                                <h4 class="alert-heading text-center"> <i class="fa fa-info-circle" aria-hidden="true"></i></h4>
                                Sembra che non c'è alcuna corrispondeza tra i file
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-right">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal"><i class="fas fa-times"></i>
                        Chiudi
                </button>
                </div>
            </div>
        </div>
    </div>





</template>
<script>

import Pagine from '@/components/utils/Pagine.vue'
import DatePicker from '@/components/utils/DatePicker.vue'
import Select2 from '@/components/utils/Select2.vue'



export default {
    name: "Fatture",
    components: {
        Pagine,
        DatePicker,
    },
    data: function () {
        return {
            filters: global.filters,
            search: {
                PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 50 },
                ID_FATTURA: { TYPE: 'TEXT', VALUE: '' },
                FK_ID_CLIENTE: { TYPE: 'TEXT', VALUE: '' },
                NUMERO_FATTURA: { TYPE: 'TEXT', VALUE: '' },
                FK_ID_TIPO: { TYPE: 'COMBO', VALUE: '' },
                FK_ID_CALCOLO_MODALITA_IMPORTO: { TYPE: 'COMBO', VALUE: '' },
                DENOMINAZIONE: { TYPE: 'TEXT', VALUE: '' },
                DESCRIZIONE_OFFERTA: { TYPE: 'TEXT', VALUE: '' },
                FK_ID_FORNITORE: { TYPE: 'COMBO', VALUE: '' },
                DATA_SCADENZA: { TYPE: 'DATE', VALUE: '' },
                DATA_CONTABILIZZAZIONE: { TYPE: 'DATE', VALUE: '' },
                DATA_REGISTRAZIONE: { TYPE: 'DATE', VALUE: '' },
                DESCRIZIONE_AGENTE: { TYPE: 'TEXT',VALUE: ''},
                INCASSATO: { TYPE: 'TEXT', VALUE: '' },
                IMPORTO: { TYPE: 'TEXT', VALUE: '' },
                SALDO: { TYPE: 'TEXT', VALUE: '' },
                PAGATA: { TYPE: 'COMBO', VALUE: '' },
            },
            arrayFatture: new Array(),
            fatturaSelezionata: {},
            infoSelezionata: {},
            infoElab: {},
            showFilters: false,
        }
    },
    methods: {
        openInfoElaborazione: function(elab){
            if(elab.ELABORATO != 1){
                this.infoElab = utils.clone(elab);
                utils.openModal('popUpElaborazione')
            }
        },
        modificaFattore: function(fattura){
            this.fatturaSelezionata = utils.clone(fattura);
            this.fatturaSelezionata.INCASSATO = Math.abs(this.fatturaSelezionata.INCASSATO);
            var modal = utils.openModal('popUpFattura');
        },
        moreInfo: function (idFattura) {
            var modal = utils.openModal('popUpInfo');
            global.utils.get('/dcp/fattura/info', { ID_FATTURA: idFattura }, (response) => {
                if (response.esito == 0) {
                    this.infoSelezionata = response.data
                    utils.alert.success(response.messaggio);
                }
            });
        },
        getFatture: function () {
            global.utils.get('/dcp/fatture', {}, (response) => {
                this.arrayFatture = response.data;
            });
        },
        salvaFattura: function () {
            this.fatturaSelezionata.FATTORE_FAT = this.filters.formatWithCommas(this.fatturaSelezionata.FATTORE_FAT);
            this.fatturaSelezionata.INCASSATO = this.filters.formatWithCommas(this.fatturaSelezionata.INCASSATO);
            if (parseFloat(this.fatturaSelezionata.INCASSATO) > parseFloat(this.fatturaSelezionata.IMPORTO)) {
                console.log(this.fatturaSelezionata.INCASSATO, this.fatturaSelezionata.SALDO);
                utils.alert.warning("Non puoi superare l'importo");
                return;
            }

            global.utils.put('/dcp/fattura', this.fatturaSelezionata, (response) => {
                if (response.esito == 0) {
                    this.getFatture();
                    var modal = utils.closeModal('popUpFattura')
                    utils.alert.success(response.messaggio);
                }
            });
        },
    },
    computed: {
        paginatedList() {
            if(this.$root.test == false){
                var arr = utils.inGrid(this.arrayFatture, this.search);
                return arr;
            }
            else{
                let result = utils.inGrid(this.arrayFatture, this.search);                
                if (Array.isArray(result.arr)) {
                    if(result.arr[0]?.MC_FATTURATI != 0){
                        result.arr = result.arr.filter(fattura => {
                        return (fattura.MC_FATTURATI > 0 && fattura.TIPO_RECORD == trim('CONDOMINIO'));
                        });
                        result.count = (result.arr).length;
                    }else{
                        result.arr = result.arr.filter(fattura => {
                        return fattura;
                        });
                    }
                } else {
                    console.warn('result.arr non è un array', result);
                }
                return result;
            }
        },
    },

    created: function () {
        this.getFatture();
    }
}
</script>

<style scoped>

@media (max-width: 767px) {
    .kt-portlet__head {
        height: 0 !important;
        overflow: hidden;
    }
}

/* Quando la larghezza della finestra è maggiore o uguale a 1536 */
@media (min-width: 1282px) {
  .isprint-grid-container {
    margin-top: 20px;
    width: auto;
    table-layout: auto;
  }
}

/* Quando la larghezza della finestra è inferiore a 1536px */
@media (max-width: 1281px) {
  .isprint-grid-container {
    margin-top: 100px;
  }
}
@media (min-width: 768px) and (max-width: 1281px) {
    .isprint-grid-container {
        margin-top: 100px;
    }
}

/* Mobile - inferiore a 768px */
@media (max-width: 767px) {
    .isprint-grid-container {
        margin-top: 20px;
    }
}

.mobile-page-title {
    padding: 15px;
    background: linear-gradient(135deg, #800080, #004B80);
    color: white;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    position: sticky;
    top: 0;
    z-index: 100;
}

.mobile-page-title h4 {
    margin: 0;
    color: white;
}

.mobile-page-title i {
    margin-right: 8px;
}

/* Pallino indicatore contratto associato */
.contratto-indicator {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: linear-gradient(135deg, #808000, #D9CB34);
    margin-right: 6px;
    box-shadow: 0 0 5px rgba(128, 128, 0, 0.5);
    vertical-align: middle;
}

</style>